"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeDashboard_de_de = void 0;
function backofficeDashboard_de_de() {
    return {
        "backoffice.dashboard.title": "Dashboard",
        "backoffice.dashboard.createcompany": "Firma erstellen",
        "backoffice.dashboard.createcompanysub": "Mit einer Firma verwalten Sie Ihre Projekte, Benutzer und Abrechnungen.",
        "backoffice.dashboard.createproject": "Projekt erstellen",
        "backoffice.dashboard.createprojectsub": "Über Projekte können Sie Leistungen wie CMS, OMS oder die Workflow Engine erstellen und buchen.",
        "backoffice.dashboard.completeprofile": "Profil vervollständigen",
        "backoffice.dashboard.completeprofilesub": "Bitte tragen Sie Ihren Vor- und Nachnamen ein, damit andere Nutzer Sie besser identifizieren können.",
        "backoffice.dashboard.gotoprofile": "Zum Profil",
        "backoffice.dashboard.gotocompany": "Zu den Projekten",
        "backoffice.dashboard.gotocompanies": "Zu den Firmen",
        "backoffice.dashboard.gotoproject": "Zu \"${project}\"",
        "backoffice.dashboard.companymessage": "Klicken Sie auf den Button, um direkt zum Profil der Firma \"${company}\" zu gelangen.",
        "backoffice.dashboard.projectmessage": "Klicken Sie auf den Button, um direkt zu dem Project \"${project}\" zu gelangen.",
        "backoffice.dashboard.recentcompany": "Zuletzt geöffnete Firma",
        "backoffice.dashboard.recentproject": "Zuletzt geöffnetes Projekt",
        "backoffice.dashboard.incominginvite": "Ausstehende Einladung",
        "backoffice.dashboard.norecentproject": "Kein zuletzt geöffnetes Projekt gefunden",
        "backoffice.dashboard.norecentprojectsub": "Leider wurde kein neues Projekt gefunden. Sie können neue Projekt innerhalb einer Firma anlegen",
        "backoffice.dashboard.companydashboard": "Firmen Dashboard",
        "backoffice.dashboard.projectdashboard": "Projekt Dashboard",
        "backoffice.dashboard.customsnackbarcontent.button": "Klicken Sie hier um mehr zu erfahren!",
        "backoffice.dashboard.customsnackbarcontent.text": "Das Backoffice wurde auf Version ${backofficeVersion} aktualisiert"
    };
}
exports.backofficeDashboard_de_de = backofficeDashboard_de_de;
